<script lang="ts" setup>
    import Expense from '~/app/invoicing/models/Expense';

    interface Props {
        content: Expense;
        index?: number;
    }

    interface Emits {
        (e: 'click', expense: Expense): void;
        (e: 'contextmenu', expense: Expense, event: MouseEvent): void;
    }

    const props = defineProps<Props>();
    const emit = defineEmits<Emits>();

    const handleClick = () => {
        emit('click', props.content);
    };

    const handleContextMenu = (event: MouseEvent) => {
        emit('contextmenu', props.content, event);
    };

    const animationDelay = computed(() => {
        return props.index !== undefined ? `${props.index * 0.1 + 0.05}s` : '0s';
    });
</script>

<template>
    <article
        class="flex items-center w-full py-4 text-sm transition-all cursor-pointer hover:bg-neutral-100 px-[10px] rounded-[10px] animate-appear"
        :style="{ animationDelay }"
        @click.prevent="handleClick"
        @contextmenu="handleContextMenu"
    >
        <!-- Expense info -->
        <div class="min-w-[15%]">
            <h3 :class="$theme('dashboard.itemTitle')">
                {{ content.title || '-' }}
            </h3>
            <p
                v-if="content.date"
                :class="$theme('dashboard.subtitle')"
                class="block text-xs text-neutral-600"
            >
                {{ content.date.toEUDateString() }}
            </p>
        </div>

        <!-- Contact name -->
        <div
            v-if="content.contact"
            class="flex-1 ml-2 min-w-[200px] truncate"
        >
            <span
                :class="$theme('dashboard.itemTitle')"
                class="font-medium"
            >
                {{ content.contact?.displayName }}
            </span>
        </div>

        <!-- Total amount -->
        <div
            :class="$theme('dashboard.itemTitle')"
            class="w-[100px] text-right mr-5 ml-auto"
        >
            {{ $price(content.total) }}
        </div>

        <!-- FR e-invoicing lifecycle status (received documents) -->
        <div
            v-if="content.currentEinvoicingReceiving?.lifecycleStatus"
            class="mr-3"
        >
            <InvoicingEInvoicingLifecycleBadge :status="content.currentEinvoicingReceiving.lifecycleStatus" />
        </div>

        <!-- Status badge -->
        <div class="w-[100px]">
            <UiStatusBadge :status="content.status" />
        </div>
    </article>
</template>
